//breakpoints
// 576, 768, 992, 1200, 1600

//containerWidths
// [540, 740, 960, 1140, 1540]
export const size = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  xxl: "1600px",
}

export const containerWidths = {
  sm: "540px",
  md: "740px",
  lg: "960px",
  xl: "1140px",
  xxl: "1540px",
}

export const breakpoint = {
  sm: `@media only screen and (min-width: ${size.sm})`,
  md: `@media only screen and (min-width: ${size.md})`,
  lg: `@media only screen and (min-width: ${size.lg})`,
  xl: `@media only screen and (min-width: ${size.xl})`,
  xxl: `@media only screen and (min-width: ${size.xxl})`,
}
